import PropTypes from 'prop-types';
import React from 'react';
import DownloadReport from './button/DownloadReport';
import {
  StyledReportTable,
  StyledHead,
  StyledDownloadPeriodContent,
} from './styled';

export const DataTable = ({ children }) => <StyledReportTable>{children}</StyledReportTable>;

DataTable.propTypes = {
  children: PropTypes.any,
};

export const DataTableHeader = ({ children }) => <StyledHead >{ children }</StyledHead>;

DataTableHeader.propTypes = {
  children: PropTypes.any,
};

export const DataTableDownloadReport = ({
  reportName = '',
  onDownloadReport = () => null,
}) => (
  <StyledDownloadPeriodContent>
    <DownloadReport
      reportName={reportName}
      onDownloadReport={onDownloadReport}
    />
  </StyledDownloadPeriodContent>
);

DataTableDownloadReport.propTypes = {
  onDownloadReport: PropTypes.func,
  reportName: PropTypes.string,
};
